import React, { ReactElement } from 'react'
import { ArtData } from '@/database/art'
import { formatDateString } from '@/utils/formatting'
import Link from 'next/link'
import { shortenAddress } from '@/utils/shortenAddress'

const VotesClaimsOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    return (
        <div>
            {artData && (
                <div>
                    <ul>
                        {artData.claims.map((claimData) => (
                            <div key={'#claim-details-' + claimData.claim.id}>
                                <span className="gray">#{claimData.claim.id}&nbsp;</span>
                                <span className={'white underline'}>
                                    <Link
                                        href={'/crazy#nft-' + claimData.castingArt.nft.tokenId}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {'NFT #' + claimData.castingArt.nft.tokenId}
                                    </Link>
                                </span>
                                <span className="gray">&nbsp;claims&nbsp;</span>
                                <span className={'white underline'}>
                                    <Link
                                        href={'/crazy#nft-' + claimData.targetArt.nft.tokenId}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {'NFT #' + claimData.targetArt.nft.tokenId}
                                    </Link>
                                </span>
                                <span className="gray">&nbsp;for&nbsp;</span>
                                <span className="white">
                                    {parseFloat(claimData.claim.amount).toFixed(2)}
                                    <span className="gray">&nbsp;by&nbsp;</span>
                                    <span className="white">{shortenAddress(claimData.user.walletAddress)}&nbsp;</span>
                                </span>
                                <span className="gray">&nbsp;at&nbsp;</span>
                                <span className="gray">{formatDateString(claimData.claim.createdAt)}&nbsp;</span>
                            </div>
                        ))}
                        {artData.votes.map((voteData) => (
                            <div key={'#vote-details-' + voteData.vote.id}>
                                <span className="gray">#{voteData.vote.id}&nbsp;</span>
                                <span className="white">{parseFloat(voteData.vote.amount).toFixed(2)}</span>
                                <span className="gray">&nbsp;votes&nbsp;by&nbsp;</span>
                                <span className="white">
                                    {shortenAddress(voteData.vote.voteUser.walletAddress)}&nbsp;
                                </span>
                                <span className="gray">&nbsp;at&nbsp;</span>
                                <span className="gray">{formatDateString(voteData.vote.createdAt)}&nbsp;</span>
                            </div>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default VotesClaimsOverview
